import { Record } from 'immutable';

const AddressDefaults = {
  id: null,
  name: null,
  addr1: null,
  addr2: null,
  city: null,
  state: null,
  zip_code: null
};

class Address extends Record(AddressDefaults) {}

export default Address;



// WEBPACK FOOTER //
// banquet/models/Address.js